import { Form, useFormikContext } from 'formik'
import { HelperWrapper, TextInputWithHelper } from 'src/components'
import { CreateActiveRedirectURLDto } from 'src/types/redirect-url.type'
import { useStyles } from './styes'
import { Button } from '@mui/material'

interface IProps {
  isTablet?: boolean
}

export const RedirectURLFromCreate = ({ isTablet }: IProps) => {
  const { handleChange, values, errors, dirty } = useFormikContext<CreateActiveRedirectURLDto>()
  const style = useStyles()
  return (
    <Form className={isTablet ? style.modalTablet : style.modal}>
      <TextInputWithHelper
        inputName="note"
        handleChange={handleChange}
        value={values.note}
        error={errors.note}
        inputUpperLabel={
          <HelperWrapper t={'redirect-url-note'} verticalPosition={10} isColorInherited size={11} />
        }
      />
      <TextInputWithHelper
        inputName="redirect_url"
        handleChange={handleChange}
        value={values.redirect_url}
        error={errors.redirect_url}
        inputUpperLabel={
          <HelperWrapper t={'redirect-url-text'} verticalPosition={10} isColorInherited size={11} />
        }
      />
      <TextInputWithHelper
        inputName="redirect_target"
        handleChange={handleChange}
        value={values.redirect_target}
        error={errors.redirect_target}
        inputUpperLabel={
          <HelperWrapper
            t={'redirect-target-text'}
            verticalPosition={10}
            isColorInherited
            size={11}
          />
        }
      />
      <Button type="submit" disabled={!dirty}>
        <HelperWrapper t={'save-button-text'} />
      </Button>
    </Form>
  )
}
